<sm-title-bar pageTitle="{{ 'business_details.page_header' | translate }}"  [showBackToDashboard]="true">
<ng-template #addButton>
  <button mat-flat-button color="accent" (click)="createNewBusiness()">
    Create new business
    <mat-icon class="material-icons-round" [inline]="true">add_circle</mat-icon>
  </button>
</ng-template>
</sm-title-bar>

<!-- <div *ngIf="loader" class="loader">
  <mat-spinner></mat-spinner>
</div> -->
<br />
<div class="merchant_detail_sec" *ngIf="_entityDetails.length > 0">
  <div class="mrt_offe">
    <div class="row">
      <div class="col-sm-5">
        <div class="drt_head">
          <!-- <div class="merchant_header">

                   </div> -->
        </div>
        <div class="list_user">
          <a href="javascript:void(0)" class="admin_category">
            <div class="image-cont">
              <img
                class="merchant-header-image"
                [src]="_entityDetails[0].imageThumbUrl"
                onerror="this.src='../../../../assets/images/entity_placeholder.png'"
              />
            </div>

            <div class="card_header1">
              <div class="adm_set">
                <h2 style="display: inline;">{{ "business_details.about" | translate }}</h2>
                <button
                    mat-icon-button
                    [matMenuTriggerFor]="menuopt"
                    class="profile_button"
                    class="opt"
                  >
                    <mat-icon class="material-icons-outlined"
                      >more_horiz</mat-icon
                    >
                  </button>
                  <mat-menu #menuopt="matMenu">
                    
                    <button mat-menu-item (click)="uploadMedia()">
                      <mat-icon class="material-icons-outlined"
                        >upload</mat-icon
                      >
                      <span class="menu_text">{{
                        "business_details.upload" | translate
                      }}</span>
                    </button>
                    <button mat-menu-item (click)="viewMedia()">
                      <mat-icon class="material-icons-outlined"
                        >collections_bookmark</mat-icon
                      >
                      <span class="menu_text">{{
                        "business_details.media_gallery" | translate
                      }}</span>
                    </button>
                  </mat-menu>
                <!-- <img src="https://pbs.twimg.com/profile_images/1455185376876826625/s1AjSxph_400x400.jpg"> -->
              </div>
              <!-- <div class="met_inc" >
                                <i class="fa fa-user" aria-hidden="true"></i>
                            </div> -->
            </div>

            <div class="card_body">
              <div class="sub_one">
                <!-- <span class="material-icons">
                                location_on
                                </span> -->
                <span class="details-text">{{
                  _entityDetails[0].entityDesc && _entityDetails[0].entityDesc != 'null' 
                    ? _entityDetails[0].entityDesc.length > 500
                      ? _entityDetails[0].entityDesc.substring(0, 500) + "..."
                      : _entityDetails[0].entityDesc
                    : "No description added yet"
                }}</span>

              </div>
              <div class="row" style="margin-top: 15px;" *ngIf="_entityDetails[0].isActive == 0">
                <div class="col-sm-1">
                  <mat-icon class="material-icons-outlined" style="color:#ff0000;"
                  >warning</mat-icon
                >
                </div>
                <div class="col-sm-11">
                  <p>{{
                    "business_details.deactivate_text" | translate
                  }}</p>
                </div>
              </div>
   
            </div>
          </a>
        </div>
      </div>
      <div class="col-sm-7">
        <div class="drt_head">
          <!-- the upar wala div will come here -->
        </div>
        <div class="list_user">
          <a href="javascript:void(0)" class="admin_category">
            <div class="card_header chead">
              <div class="adm_set">
                <div>
                  <span class="name_cont">{{
                    _entityDetails[0].entityName && _entityDetails[0].entityName != 'null' ? _entityDetails[0].entityName : 'No name added'
                  }}</span>
                  <button
                    mat-icon-button
                    [matMenuTriggerFor]="menu"
                    class="profile_button"
                    class="share"
                  >
                    <mat-icon class="material-icons-outlined"
                      >more_vert</mat-icon
                    >
                  </button>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="editBusiness()">
                      <mat-icon class="material-icons-outlined">edit</mat-icon>
                      <span class="menu_text">{{
                        "business_details.edit" | translate
                      }}</span>
                    </button>
                    <!-- <button mat-menu-item (click)="uploadMedia()">
                      <mat-icon class="material-icons-outlined"
                        >upload</mat-icon
                      >
                      <span class="menu_text">{{
                        "business_details.upload" | translate
                      }}</span>
                    </button> -->
                    <button mat-menu-item (click)="shareBusiness()">
                      <mat-icon class="material-icons-outlined"
                        >share</mat-icon
                      >
                      <span class="menu_text">{{
                        "business_details.share" | translate
                      }}</span>
                    </button>
                    <button mat-menu-item (click)="openDocuments()">
                      <mat-icon class="material-icons-outlined"
                        >note</mat-icon
                      >
                      <span class="menu_text">{{
                        "business_details.documents" | translate
                      }}</span>
                    </button>
                    <button mat-menu-item (click)="deleteBusiness()">
                      <mat-icon class="material-icons-outlined"
                        >delete</mat-icon
                      >
                      <span class="menu_text">{{
                        "business_details.delete" | translate
                      }}</span>
                    </button>
                  </mat-menu>
                  <!-- <span class="material-icons share"> more_vert </span> -->
                </div>

                <!-- <img src="https://pbs.twimg.com/profile_images/1455185376876826625/s1AjSxph_400x400.jpg"> -->
              </div>

              <!-- <div class="met_inc" >
                              <i class="fa fa-user" aria-hidden="true"></i>
                          </div> -->
            </div>
            <div class="card_body cbody">
              <h2>{{ "business_details.basic_info" | translate }}</h2>
              <br />
              <div class="row">
                <div class="col-md-6">
                  <div class="sub_one sub_margin">
                    <div class="sub_one_cont">
                      <div>
                        <span class="material-icons icon_mat"> face </span>
                      </div>

                      <div class="entity_detail make_text_grey">
                        {{ "business_details.creator_name" | translate }}
                      </div>
                    </div>
                    <div class="sub_one_cont main_text">
                      <div class="entity_detail">
                        <!-- {{ _entityDetails[0].ownerPhone }} -->
                        {{ _entityDetails[0].creatorName && _entityDetails[0].creatorName != 'null' ? _entityDetails[0].creatorName : 'No creator name added' }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="sub_one sub_margin">
                    <div class="sub_one_cont">
                      <div>
                        <span class="material-icons icon_mat"> call </span>
                      </div>

                      <div class="entity_detail make_text_grey">
                        {{ "business_details.creator_phone" | translate }}
                      </div>
                    </div>
                    <div class="sub_one_cont main_text">
                      <div class="entity_detail">
                        <!-- {{ _entityDetails[0].ownerPhone }} -->
                        {{ _entityDetails[0].creatorPhone && _entityDetails[0].creatorPhone != 'null' ? _entityDetails[0].creatorPhone : 'No phone added'}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="sub_one sub_margin">
                    <div class="sub_one_cont">
                      <div>
                        <span class="material-icons icon_mat"> face </span>
                      </div>

                      <div class="entity_detail make_text_grey">
                        {{ "business_details.owner_name" | translate }}
                      </div>
                    </div>
                    <div class="sub_one_cont main_text">
                      <div class="entity_detail">
                        {{ _entityDetails[0].ownerName && _entityDetails[0].ownerName != 'null' ? _entityDetails[0].ownerName : 'No owner name added' }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="sub_one sub_margin">
                    <div class="sub_one_cont">
                      <div>
                        <span class="material-icons icon_mat"> call </span>
                      </div>

                      <div class="entity_detail make_text_grey">
                        {{ "business_details.owner_phone" | translate }}
                      </div>
                    </div>
                    <div class="sub_one_cont main_text">
                      <div class="entity_detail">
                        {{ _entityDetails[0].ownerPhone && _entityDetails[0].ownerPhone != 'null' ? _entityDetails[0].ownerPhone : 'No owner phone added'}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="sub_one sub_margin">
                    <div class="sub_one_cont">
                      <div>
                        <span class="material-icons icon_mat"> call </span>
                      </div>
                      <div class="entity_detail make_text_grey">
                        {{ "business_details.entity_phone" | translate }}
                      </div>
                    </div>
                    <div class="sub_one_cont main_text">
                      <div class="entity_detail">
                        {{ _entityDetails[0].entityPhone && _entityDetails[0].entityPhone != 'null' ? _entityDetails[0].entityPhone : 'No entity phone added'}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="sub_one sub_margin">
                    <div class="sub_one_cont">
                      <div>
                        <span class="material-icons icon_mat">
                          location_on
                        </span>
                      </div>
                      <div class="entity_detail make_text_grey">
                        {{ "business_details.business_location" | translate }}
                      </div>
                    </div>
                    <div class="sub_one_cont main_text">
                      <div class="entity_detail">
                       
                        {{
                          _entityDetails[0].addressInfo.address_line.length > 90
                            ? _entityDetails[0].addressInfo.address_line.substring(0, 90) +
                              "..."
                            : _entityDetails[0].addressInfo.address_line
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row"  [ngStyle]="{'padding-top': _entityDetails[0].addressInfo.address_line.length > 59 ? '100px' : '120px'}">
                <div class="col-md-12">
                  <div class="sub_one_cont main_text" style="margin-left: 0px !important; ">
                    <div class="entity_detail" style="    color: #ff0064;
                    font-weight: 600;
                    font-size: 1rem;
                " *ngIf="toShowCheckHome === 1">
                      <!-- {{ _entityDetails[0].ownerPhone }} -->
                      {{
                        "business_details.home_available" | translate
                      }}
                    </div>
                    <div class="entity_detail" style="    color: #ff0064;
                    font-weight: 600;
                    font-size: 1rem;
                " *ngIf="toShowCheckHome === 0">
                      <!-- {{ _entityDetails[0].ownerPhone }} -->
                      {{
                        "business_details.home_unavailable" | translate
                      }}
                    </div>
                  </div>
                  <mat-slide-toggle class="share" (change)="onToggleChange($event,0)" [checked]="toShowCheckHome === 1"></mat-slide-toggle>
                </div>
                <div class="col-md-12">
                  <div class="sub_one_cont main_text" style="margin-left: 0px !important; ">
                    <div class="entity_detail" style="    color: #ff0064;
                    font-weight: 600;
                    font-size: 1rem;
                " *ngIf="toShowCheckShop === 1">
                      <!-- {{ _entityDetails[0].ownerPhone }} -->
                      {{
                        "business_details.shop_available" | translate
                      }}
                    </div>
                    <div class="entity_detail" style="    color: #ff0064;
                    font-weight: 600;
                    font-size: 1rem;
                " *ngIf="toShowCheckShop === 0">
                      <!-- {{ _entityDetails[0].ownerPhone }} -->
                      {{
                        "business_details.shop_unavailable" | translate
                      }}
                    </div>
                  </div>
                  <mat-slide-toggle class="share" (change)="onToggleChange($event,1)" [checked]="toShowCheckShop === 1"></mat-slide-toggle>
                </div>
              </div>
            </div>

            <!-- <div class="card_body cbody">
              <div class="sub_one sub_margin">
                <p class="make_text_grey">Shop availability:</p>
                <span
                  class="make_text_pink"
                  *ngIf="_entityDetails[0].shopServiceStatus === 1"
                  >Service available now</span
                >
                <span
                  class="make_text_pink"
                  *ngIf="_entityDetails[0].shopServiceStatus === 0"
                  >Service not available now</span
                >
                <span
                  *ngIf="_entityDetails[0].shopServiceStatus === 1"
                  class="material-icons testicons"
                >
                  check_circle_outline
                </span>
                <span
                  *ngIf="_entityDetails[0].shopServiceStatus === 0"
                  class="material-icons testicons"
                >
                  highlight_off
                </span>
              </div>
              <div class="sub_one">
                <p class="make_text_grey">Home availability:</p>
                <span
                  class="make_text_pink"
                  *ngIf="_entityDetails[0].homeServiceStatus === 1"
                  >Service available now</span
                >
                <span
                  class="make_text_pink"
                  *ngIf="_entityDetails[0].homeServiceStatus === 0"
                  >Service not available now</span
                >
                <span
                  *ngIf="_entityDetails[0].homeServiceStatus === 1"
                  class="material-icons testicons"
                >
                  check_circle_outline
                </span>
                <span
                  *ngIf="_entityDetails[0].homeServiceStatus === 0"
                  class="material-icons testicons"
                >
                  highlight_off
                </span>
              </div>
            </div> -->
            <!-- <div class="card_body">
              <div>
                <div class="sub_one">
                  <h2>QR codes</h2>

                  <p>
                    Home:
                    <span class="linkUnlinkText">{{
                      this.homeQRCode != "" && this.homeQRCode != null
                        ? this.homeQRCode
                        : "None added"
                    }}</span>
                    (

                    <span
                      *ngIf="homeQRCode == null || homeQRCode == ''"
                      (click)="linkQR(0)"
                      class="material-icons linkUnlink"
                      >add</span
                    >
                    <span
                      *ngIf="homeQRCode != null && homeQRCode != ''"
                      (click)="unlinkQR(0)"
                      class="material-icons linkUnlink"
                      >close</span
                    >
                    )
                  </p>

                  <p>
                    Shop:
                    <span class="linkUnlinkText">{{
                      this.shopQRCode != "" && this.shopQRCode != null
                        ? this.shopQRCode
                        : "None added"
                    }}</span>
                    (

                    <span
                      *ngIf="shopQRCode == null || shopQRCode == ''"
                      (click)="linkQR(1)"
                      class="material-icons linkUnlink"
                      >add</span
                    >
                    <span
                      *ngIf="shopQRCode != null && shopQRCode != ''"
                      (click)="unlinkQR(1)"
                      class="material-icons linkUnlink"
                      >close</span
                    >
                    )
                  </p>

                </div>
              </div>
            </div> -->
          </a>
        </div>
      </div>
    </div>

    <div class="stat-cards report row row-cols-md-4 row-cols-lg-4">
      <div class="col new_sdr">
        <mat-card (click)="openBookings('1')">
          <mat-card-content>
            <h2 class="mb-0">{{ 'business_details.on_shop_bookings' | translate }}</h2>
            <!-- <p>
              <small
                >Business promotions and endorsements done on demand.</small
              >
            </p> -->
            <!-- <h1>jhjhgkj</h1> -->
          </mat-card-content>
          <!-- <mat-card-actions class="text-end">
                  <button
                    mat-button
                    [routerLink]="['/promotion', 'business-promotion']"
              
                  >
                    View details
                    <mat-icon class="material-icons-round"> arrow_forward </mat-icon>
                  </button>
                </mat-card-actions> -->
        </mat-card>
      </div>
      <div class="col new_sdr">
        <mat-card (click)="openBookings('0')">
          <mat-card-content>
            <h2 class="mb-0">{{ 'business_details.home_service' | translate }}</h2>
            <!-- <p>
              <small
                >Business promotions and endorsements done on demand.</small
              >
            </p> -->
            <!-- <h1>jhjhgkj</h1> -->
          </mat-card-content>
          <!-- <mat-card-actions class="text-end">
                  <button
                    mat-button
                    [routerLink]="['/promotion', 'business-promotion']"
              
                  >
                    View details
                    <mat-icon class="material-icons-round"> arrow_forward </mat-icon>
                  </button>
                </mat-card-actions> -->
        </mat-card>
      </div>
      <div class="col">
        <mat-card (click)="openServices()">
          <mat-card-content>
            <h2 class="mb-0">{{ 'business_details.service_&_charges' | translate }}</h2>
            <!-- <p>
              <small
                >Business promotions and endorsements done on demand.</small
              >
            </p> -->
            <!-- <h1>jhjhgkj</h1> -->
          </mat-card-content>
          <!-- <mat-card-actions class="text-end">
                  <button
                    mat-button
                    [routerLink]="['/promotion', 'business-promotion']"
              
                  >
                    View details
                    <mat-icon class="material-icons-round"> arrow_forward </mat-icon>
                  </button>
                </mat-card-actions> -->
        </mat-card>
      </div>
      <div class="col">
        <mat-card (click)="openBookingHistory()">
          <mat-card-content>
            <h2 class="mb-0">{{ 'business_details.booking_history' | translate }}</h2>
            <!-- <p>
              <small
                >Business promotions and endorsements done on demand.</small
              >
            </p> -->
            <!-- <h1>jhjhgkj</h1> -->
          </mat-card-content>
          <!-- <mat-card-actions class="text-end">
                  <button
                    mat-button
                    [routerLink]="['/promotion', 'business-promotion']"
              
                  >
                    View details
                    <mat-icon class="material-icons-round"> arrow_forward </mat-icon>
                  </button>
                </mat-card-actions> -->
        </mat-card>
      </div>
    </div>

    <div class="row " style="margin-top: 20px;
    margin-bottom: 30px;">
      <div class="col-lg-12 col-md-12">
        
        <div class="links_container">
          <mat-card-header class="justify-content-between align-items-center mb-3" style="padding: 5px 0 5px;">
            <mat-card-title class="fs-5 mb-0"> {{ 'business_details.other_links' | translate }} </mat-card-title>
            
          </mat-card-header>
          <div style="background: #f5f5f5;">
            <div class="cdf_srd"  style="border-bottom: 1px solid lightgray;" (click)="openServiceTimings('1')">
              <div class="book_text" >
                  <div class="entry_sec">
                      <mat-icon style="color:#222">navigate_next</mat-icon>
                  </div>
                  <p style="color:black">{{ 'business_details.set_shop_service_timings' | translate }}</p>
              </div>
          </div>
            <div class="cdf_srd"  style="border-bottom: 1px solid lightgray;" (click)="openServiceTimings('0')">
              <div class="book_text" >
                  <div class="entry_sec">
                      <mat-icon style="color:#222">navigate_next</mat-icon>
                  </div>
                  <p style="color:black">{{ 'business_details.set_home_service_timings' | translate }}</p>
              </div>
          </div>
            <div class="cdf_srd"  style="border-bottom: 1px solid lightgray;" (click)="openExpenses()">
              <div class="book_text" >
                  <div class="entry_sec">
                      <mat-icon style="color:#222">navigate_next</mat-icon>
                  </div>
                  <p style="color:black">{{ 'business_details.expenses' | translate }}</p>
              </div>
          </div>
            <div class="cdf_srd"  style="border-bottom: 1px solid lightgray;" (click)="openInventory()">
              <div class="book_text" >
                  <div class="entry_sec">
                      <mat-icon style="color:#222">navigate_next</mat-icon>
                  </div>
                  <p style="color:black">{{ 'business_details.inventory_items' | translate }}</p>
              </div>
          </div>
            <div class="cdf_srd"  style="border-bottom: 1px solid lightgray;" (click)="openPurchaseList()">
              <div class="book_text" >
                  <div class="entry_sec">
                      <mat-icon style="color:#222">navigate_next</mat-icon>
                  </div>
                  <p style="color:black">{{ 'business_details.purchase_list' | translate }}</p>
              </div>
          </div>
          <div class="cdf_srd"  style="border-bottom: 1px solid lightgray;" (click)="openQRCode()">
            <div class="book_text" >
                <div class="entry_sec">
                    <mat-icon style="color:#222">navigate_next</mat-icon>
                </div>
                <p style="color:black">{{ 'business_details.qr_code' | translate }}</p>
            </div>
        </div>

            <div class="cdf_srd"   (click)="openFeedback()">
              <div class="book_text" >
                  <div class="entry_sec">
                      <mat-icon style="color:#222">navigate_next</mat-icon>
                  </div>
                  <p style="color:black">{{ 'business_details.feedback' | translate }}</p>
              </div>
          </div>
          
          </div>
         
        </div>
      </div>


      <div class="col-lg-12 col-md-12" style="margin-top: 30px;">
        <div class="links_container">
          <mat-card-header class="justify-content-between align-items-center mb-3" style="padding: 5px 0 5px;">
            <mat-card-title class="fs-5 mb-0"> {{ 'business_details.advanced_links' | translate }} </mat-card-title>
            
          </mat-card-header>
          <div style="background: #f5f5f5;">
            <div class="cdf_srd"  style="border-bottom: 1px solid lightgray;" (click)="openEmployees()">
              <div class="book_text" >
                  <div class="entry_sec">
                      <mat-icon style="color:#222">navigate_next</mat-icon>
                  </div>
                  <p style="color:black">{{ 'business_details.employees' | translate }}</p>
              </div>
          </div>
            <div class="cdf_srd"  style="border-bottom: 1px solid lightgray;" (click)="openTaxAndGST()">
              <div class="book_text" >
                  <div class="entry_sec">
                      <mat-icon style="color:#222">navigate_next</mat-icon>
                  </div>
                  <p style="color:black">{{ 'business_details.tax_&_gst' | translate }}</p>
              </div>
          </div>
            <div class="cdf_srd"  style="border-bottom: 1px solid lightgray;" (click)="openOnlinePayments()">
              <div class="book_text" >
                  <div class="entry_sec">
                      <mat-icon style="color:#222">navigate_next</mat-icon>
                  </div>
                  <p style="color:black">{{ 'business_details.online_payments' | translate }}</p>
              </div>
          </div>
            <div class="cdf_srd"  style="border-bottom: 1px solid lightgray;"  (click)="openDiscount()">
              <div class="book_text" >
                  <div class="entry_sec">
                      <mat-icon style="color:#222">navigate_next</mat-icon>
                  </div>
                  <p style="color:black">{{ 'business_details.discounts' | translate }}</p>
              </div>
          </div>
            <div class="cdf_srd"  style="border-bottom: 1px solid lightgray;"  (click)="openCoupons()">
              <div class="book_text" >
                  <div class="entry_sec">
                      <mat-icon style="color:#222">navigate_next</mat-icon>
                  </div>
                  <p style="color:black">{{ 'business_details.coupons' | translate }}</p>
              </div>
          </div>
           
            <div class="cdf_srd"  style="border-bottom: 1px solid lightgray;" (click)="openCustomers()">
              <div class="book_text" >
                  <div class="entry_sec">
                      <mat-icon style="color:#222">navigate_next</mat-icon>
                  </div>
                  <p style="color:black">{{ 'business_details.customers' | translate }}</p>
              </div>
          </div>
          <div class="cdf_srd" style="border-bottom: 1px solid lightgray;"  (click)="openFollowers()">
            <div class="book_text" >
                <div class="entry_sec">
                    <mat-icon style="color:#222">navigate_next</mat-icon>
                </div>
                <p style="color:black">{{ 'business_details.followers' | translate }}</p>
            </div>
        </div>
        
        <div class="cdf_srd"  style="border-bottom: 1px solid lightgray;" (click)="openBusinessPost()">
          <div class="book_text" >
              <div class="entry_sec">
                  <mat-icon style="color:#222">navigate_next</mat-icon>
              </div>
              <p style="color:black">{{ 'business_details.business_post' | translate }}</p>
          </div>
      </div>
            <!-- <div class="cdf_srd"  style="border-bottom: 1px solid lightgray;" (click)="openDocuments()">
              <div class="book_text" >
                  <div class="entry_sec">
                      <mat-icon style="color:#222">navigate_next</mat-icon>
                  </div>
                  <p style="color:black">{{ 'business_details.documents' | translate }}</p>
              </div>
          </div> -->
            <div class="cdf_srd"  style="border-bottom: 1px solid lightgray;" (click)="openReports()">
              <div class="book_text" >
                  <div class="entry_sec">
                      <mat-icon style="color:#222">navigate_next</mat-icon>
                  </div>
                  <p style="color:black">{{ 'business_details.reports' | translate }}</p>
              </div>
          </div>
            <div class="cdf_srd"  style="border-bottom: 1px solid lightgray;" (click)="openSupportTicket()">
              <div class="book_text" >
                  <div class="entry_sec">
                      <mat-icon style="color:#222">navigate_next</mat-icon>
                  </div>
                  <p style="color:black">{{
                    "business_details.support_ticket" | translate
                  }}</p>
              </div>
          </div>
            <div class="cdf_srd"  (click)="openPlanAndRenew()">
              <div class="book_text" >
                  <div class="entry_sec">
                      <mat-icon style="color:#222">navigate_next</mat-icon>
                  </div>
                  <p style="color:black">{{ 'business_details.current_plan_&_renew' | translate }}</p>
              </div>
          </div>
          </div>
         
        </div>
      </div>
    </div>
  </div>
</div>
